import React from "react";
import PropTypes from "prop-types";
import Picture from "../../components/Picture";
import { SITE_CONSTANTS } from "../../utils/constants";

import "./AppRatings.scss";

const AppRatings = ({ onlyCards }) => (
  <div className="app-ratings-section-v5">
    <div className="app-ratings-section container">
      {!onlyCards && (
        <div className="section-header">
          <h3 className="section-title">A solução mais prática, completa e segura para seu negócio</h3>
          <Picture loading="lazy" className="underline-gradient" src="/images/underline-gradient.png" alt="" />
          <h4 className="section-description">
            Quando sua operação comercial está em jogo, não há espaço para erros.
            Milhares de empresas confiam na tecnologia, anos de experiência e suporte dedicado da Mercos
          </h4>
        </div>
      )}
      <div className="ratings-wrapper">
        <div className="ia-rating-card">
          <div className="ia-rating-info">
            <div className="ia-rating-score">
              <span className="ia-rating-value">{SITE_CONSTANTS.GOOGLE_PLAY_RATING}</span>
              <span className="ia-rating-star-char">★</span>
            </div>
            <span className="ia-rating-reviews-text">{SITE_CONSTANTS.GOOGLE_PLAY_REVIEWS}</span>
          </div>
          <Picture className="ia-rating-platform-logo" alt="Google Play Logo" src="/images/site/recursos/google-play.png" />
        </div>
        <div className="ia-rating-card">
          <div className="ia-rating-info">
            <div className="ia-rating-score">
              <span className="ia-rating-value">{SITE_CONSTANTS.APP_STORE_RATING}</span>
              <span className="ia-rating-star-char">★</span>
            </div>
            <span className="ia-rating-reviews-text">{SITE_CONSTANTS.APP_STORE_REVIEWS}</span>
          </div>
          <div className="ia-rating-platform-appstore">
            <Picture className="ia-rating-platform-logo" alt="Apple Logo" src="/images/site/recursos/app-store.png" />
          </div>
        </div>
        <div className="ia-rating-card">
          <div className="ia-rating-info">
            <div className="ia-rating-score">
              <span className="ia-rating-value">{SITE_CONSTANTS.GOOGLE_BUSINESS_RATING}</span>
              <span className="ia-rating-star-char">★</span>
            </div>
            <span className="ia-rating-reviews-text">{SITE_CONSTANTS.GOOGLE_BUSINESS_REVIEWS}</span>
          </div>
          <Picture className="ia-rating-platform-logo" alt="Google Meu Negócio Logo" src="/images/site/recursos/google-meu-negocio.png" />
        </div>
      </div>
    </div>
  </div>
);

AppRatings.propTypes = {
  onlyCards: PropTypes.bool,
};

AppRatings.defaultProps = {
  onlyCards: false,
};

export default AppRatings;


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/AppRatings/AppRatings.jsx